module.exports = __webpack_public_path__ + "static/img/platform1.53d1947f.png";